module.exports = __webpack_public_path__ + "static/media/20200102_103710.5200a956.jpg";